import { z } from 'zod';

/** Integer US cents (APP-010). */
export const Cents = z.number().int().refine(Number.isSafeInteger, 'must be a safe integer');
export type Cents = z.infer<typeof Cents>;

/** ISO business date, `YYYY-MM-DD` (APP-018). */
export const PlainDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'must be YYYY-MM-DD');
export type PlainDate = z.infer<typeof PlainDate>;

/** RFC 9457 problem details, with a stable `code` the UI maps to friendly copy. */
export const Problem = z.object({
  type: z.string(),
  title: z.string(),
  status: z.number().int(),
  code: z.string(),
  detail: z.string().optional(),
  instance: z.string().optional(),
  issues: z.array(z.object({ path: z.string(), code: z.string(), message: z.string() })).optional(),
});
export type Problem = z.infer<typeof Problem>;

/**
 * Bidirectional embedding, override and isolate marks: refused wherever text can be printed in a
 * letter, so a letter can't read differently from what the form showed (APP-201).
 */
export const BIDI_MARKS = /[\u202A-\u202E\u2066-\u2069]/u;
